'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = logger;
exports.enable = enable;
exports.disable = disable;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ENABLE = 'logger/ENABLE';
var DISABLE = 'logger/DISABLE';
var initialState = {
  logger: false
};

function logger() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (state.logging) {
    console.log(action);
  }
  switch (action.type) {
    case ENABLE:
      return (0, _extends3.default)({}, state, {
        logging: true
      });
    case DISABLE:
      return (0, _extends3.default)({}, state, {
        logging: false
      });
    default:
      return state;
  }
}

function enable() {
  return {
    type: ENABLE
  };
}

function disable() {
  return {
    type: DISABLE
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/modules/logger.js
// module id = 589
// module chunks = 0